export enum MemberActionsEnum {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
}

export enum MemberTypesEnum {
    SENDER = 'SENDER',
    RECEIVER = 'RECEIVER',
}
